import { render, staticRenderFns } from "./healthTable.vue?vue&type=template&id=4fc2750a&scoped=true&"
import script from "./healthTable.vue?vue&type=script&lang=js&"
export * from "./healthTable.vue?vue&type=script&lang=js&"
import style0 from "./healthTable.vue?vue&type=style&index=0&id=4fc2750a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc2750a",
  null
  
)

export default component.exports